var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 90,
    viewBox: "0 0 58 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5616 1H5.2115L6.78873 3.70062L1 57.6766L1.93871 86.151L6.47582 87.0897L6.78873 82.9437L8.58793 80.5187L9.44842 82.4743L9.52664 85.9163L11.717 88.1066V89.28L16.0976 88.3413L17.8186 85.9163L16.8799 85.0558L17.6622 81.5356L13.9855 78.0154L14.6113 75.5904H55.3671L53.568 71.7573L54.5849 65.3428L52.7857 61.1186L54.272 54.7041L56.8039 52.5292L55.0744 51.4746L55.686 49.4286L52.5854 42.2149L45.5616 1Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAl);
export default __webpack_public_path__ + "static/media/AL.344b5523599af9871656843cbcc7b3bf.svg";
export { ForwardRef as ReactComponent };